import { render, staticRenderFns } from "./PickupGoogleSheetsConfig.vue?vue&type=template&id=31164dff&scoped=true"
import script from "./PickupGoogleSheetsConfig.vue?vue&type=script&lang=js"
export * from "./PickupGoogleSheetsConfig.vue?vue&type=script&lang=js"
import style0 from "./PickupGoogleSheetsConfig.vue?vue&type=style&index=0&id=31164dff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31164dff",
  null
  
)

export default component.exports